
import { IGetInformacaoFaturamentoUseCase } from "../../../presentation/useCases/read/get_informacao_faturamento_use_case";
import { InformacaoFaturamento } from "../../models/informacao_faturamento";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetAllinformacaoFaturamentoUseCase
 */

export class GetInformacaoFaturamentoUseCase implements IGetInformacaoFaturamentoUseCase {
  constructor(private readonly repository: IComercialRepository) { }


  async getInformacaoFaturamento(idInfFaturamento: number): Promise<InformacaoFaturamento> {
    const response = await this.repository.getInformacaoFaturamento(idInfFaturamento)
    return response;

  }
}

